// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"b86a59a0","162":"5efaa986","239":"e7f11d06","243":"c390e97c","295":"6c48d076","488":"f07dc0c3","591":"5960f919","667":"a0387564","777":"dc78f857","977":"5ce93d36"}[chunkId] + ".chunk.js";
};